export enum FiltersType {
    text = 1,
    date = 2,
    number = 3,
    combo = 4,
    time = 5
}
